import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import useAxios from 'axios-hooks';

import { short } from '../../common/formatting/date';
import FullscreenToggle from '../components/FullscreenToggle';
import isEmpty from 'lodash.isempty';

const Medications = ({
	patientId,
	onExpand,
	onContract,
	isDependentEvisit,
	dependentMedications,
}) => {
	const [{ data, loading, error }, getMedications] = useAxios(
		`/patients/${patientId}/medications`,
		{ manual: true }
	);

	useEffect(() => {
		if (!isDependentEvisit) {
			getMedications();
		}
	}, [isDependentEvisit]);

	return (
		<div>
			<FullscreenToggle onExpand={onExpand} onContract={onContract} />
			<table className="table table-striped">
				<thead>
					<tr>
						<th>Medication</th>
						<th>Onset Date</th>
						<th>Taking</th>
						<th>Source</th>
						<th>Updated On</th>
					</tr>
				</thead>
				<tbody>
					{loading && (
						<tr>
							<td colSpan={5}>Loading...</td>
						</tr>
					)}
					{isDependentEvisit && (
						<tr>
							<td colSpan={5}>
								{dependentMedications
									? `${dependentMedications}`
									: 'No medications found for this patient.'}
							</td>
						</tr>
					)}
					{!loading && data && data.length === 0 && (
						<tr>
							<td colSpan={5}>No medications found for this patient.</td>
						</tr>
					)}
					{!loading &&
						data &&
						data.map((medication) => (
							<tr key={`${medication.id}`}>
								<td>{medication.name}</td>
								<td>{short(medication.onset_dttm)}</td>
								<td>
									{medication.status &&
										medication.status === 'taking' &&
										'Active'}
									{medication.status &&
										medication.status === 'not_taking' &&
										'Historical'}
								</td>
								<td>
									{!isEmpty(medication.data_source) &&
										medication.data_source !== 'patient' &&
										medication.data_source}
								</td>
								<td>
									{!isEmpty(medication.update_dttm) &&
										short(medication.update_dttm, true, 'PP')}
								</td>
							</tr>
						))}
					{!loading && error && (
						<tr>
							<td colSpan={5} className="text-danger">
								Problem loading Allergies
							</td>
						</tr>
					)}
				</tbody>
			</table>
		</div>
	);
};

Medications.propTypes = {
	patientId: PropTypes.number.isRequired,
	onExpand: PropTypes.func.isRequired,
	onContract: PropTypes.func.isRequired,
	isDependentEvisit: PropTypes.bool,
	dependentMedications: PropTypes.string,
};

export default Medications;
